import {
  api_cancel_previous_subscription_for_past_due_path,
  api_subscription_status_path,
  api_update_subscription_for_cbpt_path,
} from '@routes';

import request from './request';

export const SUBSCRIPTION_STATUS_KEY = 'subscriptionStatus';

export enum SubscribePageType {
  Standard = 'standard',
  Dual = 'dual',
}

export interface Reporter {
  bio: string;
  name: string;
  title: string;
}

export interface SelectedOffer {
  description?: string;
  billingFrequency: string;
  code: string;
  coupon?: string;
  currentPrice: number;
  hasMultiyearCoupon?: boolean;
  isPro: boolean;
  isAnnual?: boolean;
  isMonthly?: boolean;
  isYp?: boolean;
  originalPrice: number;
  title: string;
}

export interface OfferOption extends SelectedOffer {
  billingFrequencyOverride: string;
  currentPriceDisplayOverride: number;
  description: string;
  header: string;
  isBestValue: boolean;
  isMonthlyPriced: boolean;
  showMonthlyPriceAsAnnual?: boolean;
  originalPriceDisplayOverride?: number;
  shortDescription?: string;
  subHeader: string;
  isAnnual: boolean;
  isMonthly: boolean;
  isYp: boolean;
}

export interface SubscriptionParams {
  modal?: string;
  page: string;
  code: string;
  presented_offer_codes: string[];
  referer: string;
  referring_article_id?: string;
  referrer_guid?: string;
  source: string;
  subscription_id?: string;
}

export interface SubscriptionResponse {
  affiliation: string;
  email: string;
  initialSubscriptionPrice: string;
  newCustomer?: boolean;
  offerCode: string;
  productSku: string;
  redirectTo: string;
  stripePlanName: string;
  subscriptionVariant: string;
  success?: boolean;
  trackConversion: boolean;
  giftRecipientStripeCustomerId?: string;
  userId: number;
}

export interface SubscriptionImpactEvent {
  email: string;
  initialSubscriptionPrice: string;
  newCustomer: boolean;
  offerCode: string;
  productSku: string;
  stripePlanName: string;
  userId: number;
}

export interface SubscriptionStatusParams {
  gift_offer_code?: string;
  gift_recipient_stripe_customer_id?: string;
  referer?: string;
}

export async function subscriptionStatus(
  params: SubscriptionStatusParams
): Promise<SubscriptionResponse> {
  const response = await request('get', api_subscription_status_path(params));
  return response;
}

export async function updateCbptUserSubscription(
  params: SubscriptionParams
): Promise<SubscriptionResponse> {
  const response = await request('put', api_update_subscription_for_cbpt_path(params));
  return response;
}

export async function cancelPastDuePreviousSubscription(): Promise<SubscriptionResponse> {
  const response = await request('put', api_cancel_previous_subscription_for_past_due_path());
  return response;
}
